import { createPinia as _createPinia } from "pinia";

export const createPinia = () => _createPinia();

const pinia = createPinia();

export default pinia;
